export default "/images/0fa5f3c3b14bcdb3c6600ec2999a9344.png";